import {IPickedImage, PickImage} from '@/utils/imagePicker/types';

const readUriFromFile = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    if (!file) {
      return reject(undefined);
    }
    const reader = new FileReader();
    reader.onload = () => {
      // convert image file to base64 string for preview
      if (typeof reader.result === 'string') {
        return resolve(reader.result);
      }
      return reject();
    };
    reader.onerror = () => {
      reject();
    };
    reader.readAsDataURL(file);
  });

const getImageDimensions = (
  uri: string,
): Promise<{width: number; height: number}> =>
  new Promise(async (resolve, reject) => {
    const image = document.createElement('img');

    image.onload = () => {
      return resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
    };

    image.onerror = () => {
      reject();
    };

    image.src = uri;
  });

export const pickImage: PickImage = async (): Promise<IPickedImage> => {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.addEventListener('change', async () => {
      try {
        const file = input.files?.[0];

        if (!file) {
          return reject();
        }

        const uri = await readUriFromFile(file);
        const type = file.type;
        const {width, height} = await getImageDimensions(uri);

        resolve({
          uri,
          width,
          height,
          type,
          file,
        });
      } catch (error) {
        reject();
      } finally {
        input.value = '';
      }
    });

    input.click();
  });
};
